import FluxLanding from '@/components/ai/flux-landing';
import routes from '@/config/routes';
import Layout from '@/layouts/_layout';
import Seo from '@/layouts/_seo';
import { NextPageWithLayout } from '@/types';
import { GetServerSideProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const MyPersonalAI: NextPageWithLayout = () => {
  return (
    <>
      <Seo
        title="My Personal AI - Train Custom AI Models"
        description="Train high-quality AI image models for headshots, portraits, products, and brand assets with our cutting-edge platform."
        url={routes?.myPersonalAI}
      />
      <div className="flex min-h-screen flex-col bg-gradient-to-br from-gray-50 via-gray-100 to-brand/10 dark:from-black dark:via-black dark:to-brand-dark/20">
        <FluxLanding />
      </div>
    </>
  );
};
// Layout wrapper
MyPersonalAI.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>;
};

export default MyPersonalAI;

// Server-side props fetching
export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale!, ['common'])),
    },
  };
};
